import { AddressRes, AddressTag } from '@dealstack/shared/lib/generated';

export const findAddressByTag = (addresses: AddressRes[] = [], tag: AddressTag) => {
	return addresses?.find((address) => address.tags?.includes(tag));
};

export const getMainAddress = (addresses?: AddressRes[]): AddressRes | undefined => {
	if (!addresses?.length) {
		return;
	}

	return (
		findAddressByTag(addresses, AddressTag.PRIMARY_ADDRESS) ??
		findAddressByTag(addresses, AddressTag.REGISTERED_ADDRESS) ??
		findAddressByTag(addresses, AddressTag.HEAD_OFFICE) ??
		addresses[0]
	);
};
